import React, { useContext, useEffect } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import { useNpsFeedback} from "./store";
import { FeedbackDate } from "./FeedbackTab";
import xlsx from "json-as-xlsx";
import moment from "moment";

function NpsFeedback({ data, feedbackLength }) {
  const { startDate, endDate } = useContext(FeedbackDate);
  const ratingData = data?.[0]?.rating || null;
  const {
    npsDownloadData,
    npsDownloadLoading,
    fetchNpsFeedbackDownload
  } = useNpsFeedback();

  useEffect(() => {
    fetchNpsFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  }, [startDate]);

  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        case_id:el.case_id?el.case_id:"",
        name: el.user.first_name?el.user.first_name : "",
        phoneNumber: el.user.phone_number
          ? el.user.phone_number
          : "",
        gender:el.user.gender
        ? el.user.gender
        : "",
        email: el.user.email?el.user.email:"",
        rating: el.responses[0].reply,
        customComment: el.responses[1].reply,
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      };
    });
    const data = [
      {
        sheet: "csatFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Customer Name", value: "name" },
          { label: "Customer Phone Number", value: "phoneNumber" },
          { label: "Customer Gender", value: "gender" },
          { label: "Customer Email Id", value: "email" },
          { label: "Customer Rating", value: "rating" },
          { label: "Customer Comment", value: "customComment" },
          {
            label: "Created At",
            value: "createdAt",
          },
          // {
          // 	label: "Updated At",
          // 	value: "updatedAt",
          // },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `NPS Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center my-n2">
          <div className="d-flex gap-2">
            <div className="">Experience of community</div>
            <div className="d-flex gap-2">
              <div className="fw-bold">Total Count:</div>
              <div className="fw-bold">{feedbackLength}</div>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => ExcelDownload(npsDownloadData?.feedbacks)}
              disabled={isEmpty(npsDownloadData?.feedbacks)}
            >
              Download
            </Button>
          </div>
        </div>
      }
      component={
        <div className="d-flex justify-content-between gap-4">
          <div className="w-50 mt-n2">
            {" "}
            <div className="d-flex gap-3 ms-n2">
              10 🌟
              <div className="w-50 ms-n1">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["10"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["10"]}</div>
            </div>
            <div className="d-flex gap-3">
              9 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["9"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["9"]}</div>
            </div>
            <div className="d-flex gap-3">
              8 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["8"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["8"]}</div>
            </div>
            <div className="d-flex gap-3">
              7 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["7"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["7"]}</div>
            </div>
            <div className="d-flex gap-3">
              6 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["6"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["6"]}</div>
            </div>
            <div className="d-flex gap-3">
              5 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["5"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["5"]}</div>
            </div>
          </div>
          <div className="w-50 mt-n2">
            {" "}
            <div className="d-flex gap-3">
              4 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["4"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["4"]}</div>
            </div>
            <div className="d-flex gap-3">
              3 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["3"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["3"]}</div>
            </div>
            <div className="d-flex gap-3">
              2 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["2"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["2"]}</div>
            </div>
            <div className="d-flex gap-3">
              1 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["1"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["1"]}</div>
            </div>
            <div className="d-flex gap-3">
              0 🌟
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+ratingData?.["0"] / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{+ratingData?.["0"]}</div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default NpsFeedback;
